import {useEffect, useState} from "react";
import BaseTable, {FieldType} from "@/components/table/BaseTable.tsx";
import {application} from "@/store/modules/application.ts";
import {Application} from "@/model/response/application/ReadApplicationResponse.ts";
import {entity} from "@/store/modules/entity.ts";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "@/store";
import {invite} from "@/store/modules/invite.ts";
import {user} from "@/store/modules/user.ts";
import {workspace} from "@/store/modules/workspace.ts";
import {HelpUtil} from "@/util/HelpUtil.ts";
import {StoreUtil} from "@/util/store/StoreUtil.ts";
import {notification} from "@/store/modules/notification.ts";
import {base} from "@/store/modules/base.ts";
import {ModalConstant} from "@/util/constant/ModalConstant.ts";

export default function Invite() {
    const [inviteNames, setInviteNames] = useState<any>([]);
    const dispatch = useDispatch<any>();
    const inviteState = useSelector((state: RootState) => state.invite);
    const userState = useSelector((state: RootState) => state.user);
    const workspaceState = useSelector((state: RootState) => state.workspace);
    useEffect(() => {
        dispatch(invite.action.readInvite())
        dispatch(workspace.action.readWorkSpace())
        dispatch(user.action.readUser())
    }, []);

    useEffect(() => {
        setInviteNames(inviteState.readInvite.map(item => {
            const user = userState.user.find(user => (user.userId == item.inviteSenderId))
            const workspace = workspaceState.workspace.find(it => (it.workspaceId == item.inviteWorkspaceId))

            return {
                ...item,
                inviteSenderId: user?.userFullName,
                inviteWorkspaceId: workspace ? workspace?.workspaceName : "none",
                inviteCreatedAt: HelpUtil.formatDate(item.inviteCreatedAt)
            }
        }))
    }, []);


    const showMessage = (
        response: any,
        title: "Error" | "Success" = "Success",
        type: "error" | "success" = "success"
    ) => {
        StoreUtil.execute(() => {
                dispatch(
                    notification.mutation.openModal({
                        type: type,
                        title: title,
                        body: response.responseMessage,
                    })
                )
            }
        );
    };
    const handleResendInvite = async (data: any) => {
        await dispatch(invite.action.resendInvite({
            onSuccess: (response: any) => showMessage(response, "Success", "success"),
            onError: (response: any) => showMessage(response, "Error", "error"),
            data: {
                inviteId: data.inviteId
            }
        }))

    }

    const fields: FieldType[] = [
        {label: "Email", key: "inviteEmail",},
        {label: "Workspace", key: "inviteWorkspaceId"},
        {label: "Status", key: "inviteStatus"},
        {label: "Date Sent", key: "inviteCreatedAt"},
        {label: "Link", key: "inviteId"},
        {label: "Sender", key: "inviteSenderId"},
    ]
    const refreshPage = () => {
        console.log("I am clicked")
    }


    return (
        <>
            <div className="margin-bottom margin-small">
                <div className="spec-header">Invites</div>
                <p className="paragraph">
                    A module is a self-contained unit of code that performs a specific
                    function and can be used in conjunction with other modules to build a
                    larger software system.
                </p>
                <BaseTable title={"Invites"} component={""}
                           items={inviteNames ?? []}
                           refreshPage={refreshPage}
                           showToast={false} loader={inviteState.loading}
                           fields={fields}
                           actions={{view: true}}
                           rowOptions={[{
                               optionName: 'Resend Invite', onClick: (data) => {
                                   dispatch(application.mutation.selectedApplication(data))
                                   handleResendInvite(data)
                               }
                           }, {
                               optionName: 'Update Invite', onClick: (data: Application) => {
                                   dispatch(application.mutation.selectedApplication(data))
                                   dispatch(entity.action.readByEntityApplicationId({entityApplicationId: data.applicationId}))
                               }
                           },
                               {
                                   optionName: 'Delete Invite', onClick: (data) => {
                                       dispatch(application.mutation.selectedApplication(data))
                                   }
                               },
                           ]}

                />
                <button className="text-block-2" style={{backgroundColor: "transparent", fontSize:14}}
                        onClick={() => dispatch(base.mutation.setModalOptions({
                            show: true,
                            component: ModalConstant.newMember
                        }))}>
                    + Send new invite
                </button>
            </div>
        </>
    );
}


